import styled from 'styled-components'

export const Item = styled.div`
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  color: ${props => props.theme.colors.darkText};
`
